import {Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';
import * as fromDragAndDrop from '../../reducers';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {withLatestFrom} from 'rxjs/operators';
import {DropItem} from '../../models/drag-and-drop';

@Component({
  selector: 'awair-droppable',
  templateUrl: './droppable.component.html',
  styleUrls: ['./droppable.component.scss']
})

export class DroppableComponent implements OnInit {

  @HostBinding('style.z-index') hostZIndex: number = 0;
  @HostBinding('style.opacity') hostOpacity: number = 0;

  @HostListener('mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (this.draggedZone === this.zone && this.canDrop) {
      const htmlElement: HTMLElement = this.el.nativeElement;

      // Giving setTimeOut to prevent DOM to be handled due to "dropItem.emit" before document:mouseup of draggable executes
      // This causes problem when element of draggable gets changed due to "dropItem.emit"
      setTimeout(() => {
        this.dropItem.emit({
          relativeX: event.offsetX,
          relativeY: event.offsetY,
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          relativeXPercentage: event.offsetX / htmlElement.clientWidth,
          relativeYPercentage: event.offsetY / htmlElement.clientHeight,
          data: this.draggedData
        });

        this.canDrop = false;
      }, 1);
    }
  }

  @HostListener('mouseover', ['$event'])
  onMouseOver(event: MouseEvent) {
    this.canDrop = this.isDragging && (this.draggedZone === this.zone);
  }

  @Input() zone: string;
  @Output() dropItem: EventEmitter<DropItem> = new EventEmitter<DropItem>();

  draggedZone$: Observable<[boolean, string]> = this.dragAndDropStore.pipe(
    select(fromDragAndDrop.isDragging),
    withLatestFrom(this.dragAndDropStore.select(fromDragAndDrop.dragZone))
  );

  draggedData$: Observable<any> = this.dragAndDropStore.pipe(
    select(fromDragAndDrop.draggedData)
  );

  private canDrop: boolean;
  private isDragging: boolean;
  private draggedZone: string;
  private draggedData: any;

  constructor(private dragAndDropStore: Store<fromDragAndDrop.State>,
              private el: ElementRef) {
  }

  ngOnInit() {
    this.draggedZone$.subscribe(([isDragging, draggedZone]: [boolean, string]) => {
      if (isDragging) {
        this.hostZIndex = this.zone === draggedZone ? 9999 : 0;
        this.hostOpacity = this.zone === draggedZone ? 0.3 : 0;
        this.draggedZone = draggedZone;
      } else {
        this.hostZIndex = 0;
        this.hostOpacity = 0;
      }
      this.isDragging = isDragging;
    });
    this.draggedData$.subscribe((draggedData: any) => {
      this.draggedData = draggedData;
    });
  }
}
